import React from 'react'
import { marginSizes } from '@jarvis.oddle/core/theme/default'
import OrderItemElement, {
  PromotionalOrderItem as PromotionalOrderItemElement
} from '@jarvis.oddle/core/molecules/OrderItem'
import Div from '@jarvis.oddle/core/components/Div'
import ProductImageState from 'src/components/molecules/ProductImageState'
import { useAppContext } from 'src/containers/AppContext'

export const PromotionalOrderItem = ({
  item
}: {
  item: Oms.V4.OrderItem
}): JSX.Element => {
  const { formatMoney } = useAppContext()

  return <PromotionalOrderItemElement formatMoney={formatMoney} item={item} />
}

export const OrderItem = ({ item }: { item: Oms.V4.OrderItem }): JSX.Element => {
  const { details: { imageFullUrls: [imageFullUrl] = [], imageUrls: [imageUrl] = [] } = {} } = item
  const { getProductImagePath, formatMoney } = useAppContext()
  return (
    <ProductImageState>
      {({ showImage, showDefaultImage }) => {
        const imageSrc = getProductImagePath(imageFullUrl || imageUrl, showDefaultImage, {
          shouldCache: true,
          containerWidth: 120,
          containerHeight: 120
        })
        return (
          <Div marginTop={marginSizes.small} marginBottom={marginSizes.small}>
            <OrderItemElement
              item={item}
              formatMoney={formatMoney}
              imageSrc={imageSrc}
              showImage={showImage}
            />
          </Div>
        )
      }}
    </ProductImageState>
  )
}

export default OrderItem
